import {
  ColumnExtended,
  FilterObjectType,
  FilterRequest,
  FilterRequestList,
  FilterTypes,
  parseNonLatinNumber,
} from '@evrekadev/evreka-ui-components'
import { LANGUAGES } from 'utils/languages'
import { i18n } from 'i18next'

export const getRequestFilters = (columns: ColumnExtended<any>[], filters: FilterObjectType) => {
  let requestFilters: FilterRequestList = []

  for (const [key, value] of Object.entries(filters)) {
    for (let index = 0; index < columns.length; index++) {
      const element = columns[index]
      if (element.id === key) {
        const aRequest: FilterRequest = {
          type: element.filterType ?? 'TEXT',
          key: key,
          value,
        }
        requestFilters = [...requestFilters, aRequest]
      }
    }
  }

  return requestFilters
}

export const parseFilters = (
  prev: FilterObjectType,
  i18n: i18n,
  id: string,
  value: string | string[],
  type: string,
) => {
  //TODO remove key value pair when value null, undefined or empty
  let updatedValue: { [key: string]: string | string[] } = {}
  let parsedFilter = prev
  if (value === '' || !value.length) {
    delete parsedFilter[id]
  } else if (type === FilterTypes.DATE && i18n.language === LANGUAGES.ARABIC) {
    const latinValue = parseNonLatinNumber(value as string)
    updatedValue[id] = latinValue
  } else if (type === FilterTypes.DATE_RANGE && i18n.language === LANGUAGES.ARABIC) {
    const dates = (value as string).split(',')
    const latinStartValue = parseNonLatinNumber(dates[0])
    const latinEndValue = parseNonLatinNumber(dates[1])
    updatedValue[id] = [latinStartValue, latinEndValue]
  } else {
    updatedValue[id] = value
  }
  const updateFilter: FilterObjectType = updatedValue

  return { ...parsedFilter, ...updateFilter }
}
